/*
 * @Author: tianzhi
 * @Date: 2019-11-29 16:20:27
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-12-01 15:36:36
 */
import axios from './../index';
const {
  get,
  post,
  put,
  del
} = axios;
const branchUrl = "/sso";
const saasBusinessUrl = "/saas-business";
const external = "/external";
let currentDomain = window.location.origin.indexOf('localhost') == -1 ? window.location.origin : 'http://wxrcc.rel-s.yunduoketang.cn'; // 获取token

export function getToken(code) {
  return get(branchUrl + '/onlischool/sign/token?code=' + code);
} // 获取用户信息

export function getUserInfo(access_token) {
  return get(branchUrl + '/user?access_token=' + access_token);
} // 退出登录

export function loginOut() {
  return post(`${currentDomain}/loginout`);
} // 登录设置

export function getLoginConfig(params) {
  return get(saasBusinessUrl + '/v1/front/login/config', params);
} // 登录

export function setLogin(params) {
  return post(`${saasBusinessUrl}/v1/front/login/?domain=${currentDomain}`, params);
} // 前台登录 - 获取code

export function getFrontUserCode(params) {
  return get(`${external}/api/v1/service/upgrade/front/sso/login`, params);
} // 检查手机号 或 邮箱是否被注册

export function checkMobile(params) {
  return get(`${saasBusinessUrl}/v1/front/register/checkAccount`, params);
} // 判断短信验证码是否正确短信验证码

export function checkCode(params) {
  return get(`${saasBusinessUrl}/v1/front/register/checkCode`, params);
} // 注册

export function register(data) {
  console.log(data, 'register');
  return post(`${saasBusinessUrl}/v1/front/register/register?domain=${currentDomain}`, data);
} // 判断登录页面是否需要选择省市县

export function getProvCityCountyFlag(params) {
  return get(`${saasBusinessUrl}/v1/front/register/getProvCityCountyFlag?domain=${currentDomain}`, params);
} // 第三方登录

export function openThirdlogin(params) {
  return get(`${saasBusinessUrl}/v1/front/register/openThirdlogin`, params);
} // 重新获取token

export function getOauthToken(params) {
  return post(`${branchUrl}/oauth/token?grant_type=refresh_token&refresh_token=${params.code}&client_id=${params.clientId}&client_secret=frontSecret`);
} //校验用户是否需要更改密码

export function checkPwdUpdate(params) {
  return get(`${saasBusinessUrl}/v1/student/setting/checkPwdUpdate?domain=${currentDomain}`, params);
}